import * as React from "react";
import { Field } from "formik";
import { FileField } from "../../../components/DynamicForm/Elements/FileField";

export const getFileFieldControl = (props: any) => {
  return <Field component={FileField} {...props} />;
};
